module.exports = __webpack_public_path__ + "assets/img/shouye_daoyoufuwu-xuanzhong.fe2ca1e9.svg";